<template>
  <div
    class="header-image"
    :class="image.src ? 'header-image--has-image' : 'header-image--no-image'"
  >
    <div v-if="logo" class="header-image-logo">
      <img :src="logo" alt="" />
    </div>
    <div v-if="ctaText" class="header-image-cta">
      <p
        class="header-image-cta-intro-text"
        :class="{ dark: ctaTheme == 'dark' }"
        v-html="ctaIntroText"
      ></p>
      <div class="header-image-cta-button-wrapper">
        <sanitas-button
          class="header-image-cta-button"
          secondary
          :href="ctaLink"
          :target="ctaTarget"
        >
          {{ ctaText }}
        </sanitas-button>
      </div>
    </div>
    <picture
      v-if="image.src"
      class="header-image-picture"
      :style="`padding-bottom: ${(image.ratio || 1080 / 1920) * 100}%;`"
    >
      <img :src="image.src" class="header-image-image" :srcset="image.srcSet" />
    </picture>
  </div>
</template>

<script>
import SanitasButton from '@/components/sanitas-components/SanitasButton'

export default {
  name: 'HeaderImage',
  components: {
    SanitasButton,
  },
  props: {
    image: {
      type: Object,
      required: true,
    },
    logo: {
      type: String,
      default: '',
    },
    ctaIntroText: {
      type: String,
      default: '',
    },
    ctaText: {
      type: String,
      default: '',
    },
    ctaLink: {
      type: String,
      default: '',
    },
    ctaTarget: {
      type: String,
      default: '',
    },
    ctaTheme: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="postcss" scoped>
.header-image {
  display: block;
  position: relative;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  max-width: 1660px;
  max-height: 750px;
  overflow: hidden;
}

.header-image-picture {
  display: block;
  position: relative;
  width: 100%;
  min-height: 200px;
}

.header-image-image {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.header-image-logo {
  position: absolute;
  top: 15px;
  z-index: 1;

  img {
    height: 100%;
  }
}

.header-image-cta {
  position: absolute;
  bottom: 248px;
  z-index: 1;
  left: 0;
  right: 0;
  width: 40%;
  margin-right: auto;
  margin-left: auto;
}

.header-image-cta-intro-text {
  font-family: 'Open Sans', sans-serif;
  padding-bottom: var(--spacing-4);
  font-size: 24px;
  font-weight: bold;
  color: var(--c-primary-neutral-2);
  width: 100%;
  text-align: center;
}
.header-image-cta-intro-text.dark {
  color: var(--c-primary-neutral-1);
}

.header-image-cta-button-wrapper {
  display: flex;
  justify-content: center;
}

.header-image--no-image {
  min-height: auto;
  overflow: visible;

  .header-image-logo {
    top: 45px;
    right: 0;
    height: 80px;

    img {
      float: right;
    }
  }
}

.header-image--has-image .header-image-logo {
  margin: 35px;
  height: 175px;
}

@media (max-width: 1660px) {
  .header-image--no-image .header-image-logo {
    right: 30px;
  }
}

@media (max-width: 1200px) {
  .header-image--has-image .header-image-logo {
    height: 142px;
  }

  .header-image-cta {
    width: 60%;
    bottom: 24px;
  }

  .header-image-cta-intro-text {
    font-size: 18px;
  }
}

@media (max-width: 860px) {
  .header-image--has-image .header-image-logo {
    height: 89px;
    margin: 15px 20px;
  }

  .header-image--no-image .header-image-logo {
    top: 30px;
    height: 61px;
    right: 10px;
  }
}

@media (max-width: 490px) {
  .header-image--has-image .header-image-logo {
    height: 37px;
    margin: 0;
    left: 8px;
  }

  .header-image-cta {
    width: 80%;
    bottom: 18px;
  }
  .header-image-cta-intro-text {
    font-size: 16px;
  }

  .header-image--no-image .header-image-logo {
    height: 29px;
    top: 15px;
  }
}
</style>
